﻿<div class="container container-extra main-container">

    <h1 class="page-title">
        <span *ngIf="(activeReviewsCount$ | async) > 0" [matBadge]="activeReviewsCount$ | async" matBadgeSize="large" [matBadgeOverlap]="false">{{ 'ASSESSMENTS.ACTIVE_TITLE' | translate }}</span>
        <span *ngIf="(activeReviewsCount$ | async) === 0">{{ 'ASSESSMENTS.ACTIVE_TITLE' | translate }}</span>
    </h1>
    <div class="page-subtitle">{{ 'ASSESSMENTS.ACTIVE_SUBTITLE' | translate }}</div>

    <ng-container *ngIf="itemsOpen$ | async as itemsOpen">
        <mat-card class="card-light mb-4" *ngIf="itemsOpen.length === 0">
            <mat-card-content class="text-subtitle">{{ 'ASSESSMENTS.NO_ACTIVE_ASSESSMENTS' | translate }}</mat-card-content>
        </mat-card>
    
        <div class="active-list">
            <ng-container *ngFor="let item of itemsOpen" >
                <app-assessment-list-item [item]="item" [employee]="currentEmployee" [closedGroup]="false"></app-assessment-list-item>
            </ng-container>
        </div>
    </ng-container>


    <h1 class="page-title">{{ 'ASSESSMENTS.CLOSED_TITLE' | translate }}</h1>
    <div class="page-subtitle">{{ 'ASSESSMENTS.CLOSED_SUBTITLE' | translate }}</div>

    <ng-container *ngIf="itemsClosed$ | async as itemsClosed">
        <mat-card class="card-light mb-4" *ngIf="itemsClosed.length === 0">
            <mat-card-content class="text-subtitle">{{ 'ASSESSMENTS.NO_CLOSED_ASSESSMENTS' | translate }}</mat-card-content>
        </mat-card>
    
        <ng-container *ngFor="let item of itemsClosed">
            <app-assessment-list-item [item]="item" [employee]="currentEmployee" [closedGroup]="true"></app-assessment-list-item>
        </ng-container>
    </ng-container>
    
</div>
